export default __webpack_public_path__ + "static/media/195.3bbc7f33.png";